const CompanyAndEventData  = 
  {
    id: "1",
    company: "Ergonofis",
    event: "Furniture Delivery",
    duration: "60"
  };
  
export default CompanyAndEventData